export var MuiAccordion = {
  styleOverrides: {
    root: {
      boxShadow: 'none',
      '&:before': {
        display: 'none'
      }
    }
  }
};
//# sourceMappingURL=MuiAccordion.js.map